import React, { Component } from 'react'
import {parseTimestamp} from '../../utils'

import {RESERVATION_TIME_WARNING, NO_ROOM_FOR_SELECTED_TIME} from '../../strings'

class CustomTimePicker extends Component {

    render(){
        const {
            availableHours, selectedTime, availableSpace, onTimeSelected, showWarning,
            disabled
        } = this.props
        return(
            <div className="container-custom-event-picker">
                <div className="line-header-text">Hora de visita</div>
                <select
                    className="select-css"
                    value={selectedTime}
                    onChange={onTimeSelected}
                    disabled={disabled}
                >
                {
                    availableHours.map(el => {
                        return (
                            <option
                                value={el.time}
                                key={el.time}
                            >
                                {parseTimestamp(el.time).time}
                            </option>
                        )
                    })
                }
                </select>
                {
                    showWarning ?
                    <div>
                        <div className="subtitle-info">{RESERVATION_TIME_WARNING}</div>
                        {
                            availableSpace === 0 ?
                                <div className="custom-subtitle">{NO_ROOM_FOR_SELECTED_TIME}</div> :
                                    availableSpace < 4 ?
                                    <div className="custom-subtitle">Quedan {availableSpace} espacios</div> :
                                    <div className="custom-subtitle-green">Quedan espacios disponibles</div>
                        }
                    </div> : <div></div>
                }
            </div>
        )
    }
}

export default CustomTimePicker
